import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ProjectActionTypes } from '../../redux/project/project.types';
import ReactPlayer from 'react-player';
import Header from '../../components/home/header/header.component';
import GreenLine from '../../components/greenline/greenline.component';
import FooterNew from '../../components/footernew/footernew.component';
import './toplantilar.page.styles.scss';
import { removeFirstChar } from '../../utils/utils';
import { language as MAINLANG } from '../../utils/lang';

const ToplantilarPage = () => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const setParent = (value) => dispatch({type: ProjectActionTypes.SET_PARENT, value: value });  

  if(!mounted){
    if (xprops.language === undefined){
      setParent(removeFirstChar(MAINLANG.TR.routes.meetings));  
    }else{
      setParent(removeFirstChar(xprops.language.routes.meetings));  
    }
  }  

  useEffect(() =>{
    setMounted(true);
    window.scrollTo(0,0);
  },[]);  

    return(
      <React.Fragment>
        <div className="homeWrapper">
          <Header />
          <div className="newSectionWrapper">
          <GreenLine classx="spacebottom"/>
          <div className="newContentLayerWrapper">
            <div className="subContentSectionWrapper">
              <h1 className="subContentTitle">{xprops.project.language.keywords.toplantilar}</h1>
              <p className="subContentParagraph">
                {
                  xprops.project.language.short === "TR" ? 
                    <React.Fragment>
                      Sensiz Olmaz Sessiz Olmaz, kadın uzmanlar ile medya, sivil toplum ve kamu temsilcilerini bir araya getiren toplantılar düzenliyor. 
                    </React.Fragment>
                    :
                    <React.Fragment>
                      Women Voices organizes meetings that bring together women experts and representatives from the media, civil society, academia, and public and private institutions and sectors.
                    </React.Fragment>
                }
              
              </p>
            </div>
            <div className="subContentSectionWrapper bgGrey spacerTop75">

              <h2 className="toplantiBaslik">
                {
                  xprops.project.language.short === "TR" ? 
                  <React.Fragment>
                    Sensiz Olmaz Sessiz Olmaz Tanıtım Toplantısı, 14 Haziran 2022, Istanbul
                  </React.Fragment>
                  :
                  <React.Fragment>
                    {xprops.project.language.metas.title} Launch Meeting, June 14, 2022, Istanbul
                  </React.Fragment>
                }
                
              </h2>
              <p className="subContentParagraph">
                {
                  xprops.project.language.short === "TR" ? 
                  <React.Fragment>
                    Sensiz Olmaz Sessiz Olmaz projesinin tanıtıldığı toplantı 14 Haziran 2022’de gerçekleşti. Medya sektörü, akademi, iş dünyası ve sivil toplum kuruluşlarından bilinen yüzlerin katıldığı toplantıda BBC 50:50'den Miranda Holt benzer uluslararası bir uygulama olarak BBC 50:50’ye dair deneyimlerini de paylaştı. Toplantıda Sensiz Olmaz Sessiz Olmaz projesinin kısa tanıtımıyla beraber medya eğitimlerimizde yer alan eğitmen ve katılımcılar medya eğitimi konusundaki görüşlerini aktardılar.                
                  </React.Fragment>
                  :
                  <React.Fragment>
                    The launch event for the {xprops.project.language.metas.title} initiative took place on June 14, 2022. The meeting gathered well-known figures from the media, academia, business and civil society organizations. Miranda Holt from BBC 50:50 shared insights on the BBC 50:50 initiative as a similar international program during the event. The meeting also featured a brief introduction to the Women Voices project, along with perspectives from trainers and participants involved in the media training program.
                  </React.Fragment>
                }
                
              </p>

              <div className="egitimGrid nomarginbottom">
                  <div className="egitimCol">
                    <img className="egitimColImg" src="/assets/images/toplantilar1.jpg" alt={xprops.project.language.keywords.toplantiResim1} />
                    <p className="egitimColText">{xprops.project.language.keywords.toplantiResim1}</p>
                  </div>
                  <div className="egitimCol">
                    <img className="egitimColImg" src="/assets/images/toplantilar2.jpg" alt={xprops.project.language.keywords.toplantiResim2} />
                    <p className="egitimColText">{xprops.project.language.keywords.toplantiResim2} </p>                    
                  </div>
                  <div className="egitimCol">
                    <img className="egitimColImg" src="/assets/images/toplantilar3.jpg" alt={xprops.project.language.keywords.toplantiResim3} />
                    <p className="egitimColText">{xprops.project.language.keywords.toplantiResim3}</p>                                        
                  </div>
              </div>
              <div className="videoGrid">
                  <div className="videoCol">
                    <div className="videoPlayerWrapper">                    
                      <ReactPlayer
                        url='https://www.youtube.com/watch?v=2WYKlXvNpt4'
                        className='react-player'
                        playing={false}
                        controls
                        width='100%'
                        height='100%'
                      />                              
                    </div>
                    <p className="videoColText">
                      {
                        xprops.project.language.short === "TR" ? 
                        <React.Fragment>
                          Sensiz Olmaz Sessiz Olmaz Tanıtım Toplantısı - 14 Haziran 2022
                        </React.Fragment>
                        :
                        <React.Fragment>
                          {xprops.project.language.metas.title} Introduction Meeting, June 14, 2022, Istanbul
                        </React.Fragment>
                      }
                      
                    </p>
                  </div>

              </div>

              <h2 className="toplantiBaslik">
                {
                  xprops.project.language.short === "TR" ? 
                  <React.Fragment>
                    Medyada Kadın Temsili: Engelleri Aşmak, Çözümler Üretmek, 24 Kasım 2023, Istanbul
                  </React.Fragment>
                  :
                  <React.Fragment>
                    Women’s Representation in Media: Overcoming Barriers, Creating Solutions – November 24, 2023, Istanbul
                  </React.Fragment>
                }                
                
              </h2>
              <p className="subContentParagraph">
                {
                  xprops.project.language.short === "TR" ? 
                  <React.Fragment>
                      Sensiz Olmaz Sessiz Olmaz, 24 Kasım 2023’te, Işık Üniversitsie’nin desteğiyle, “Medyada Kadın Temsili: Engelleri Aşmak, Çözümler Üretmek” adlı bir toplantı gerçekleştirdi. Medya, akademi ve sivil toplum temsilcileriyle bir araya gelinen bu toplantıda kadın uzmanların medyada görünür olmalarının önündeki engeller tartışıldı. Deneyimli gazeteciler Senem Toluay Ilgaz ve Zeynep Özyol’un medya ne ister sorusuna cevap verdiği; akademisyen Seda Demiralp’in ekran deneyimlerini paylaştığı ve araştırmacı Feyza Akınerdem’in medyada kadın uzman görünürlüğüne dair yaptığı araştırmayı sunduğu toplantıda davetlilerin katkılarıyla çözüm önerileri tartışıldı.
                  </React.Fragment>
                  :
                  <React.Fragment>
                    In November 2023, {xprops.project.language.metas.title},in partnership with Işık University, organized a meeting titled "Women’s Representation in Media: Overcoming Barriers, Creating Solutions." This gathering brought together media professionals, academics, and civil society representatives to discuss the obstacles preventing women experts from gaining visibility in the media.
                    <br/><br/>
                    The event featured:
                    <br/><br/>
                    •	Experienced journalists Senem Toluay Ilgaz and Zeynep Özyol, addressing the question: "What does the media want?" <br/>
                    •	Professor Seda Demiralp shared her on-screen experiences.<br/>
                    •	Researcher Feyza Akınerdem presented her study on the visibility of women experts in the media.<br/>

                    <br/><br/>
                    Participants contributed to discussions on possible solutions to these challenges.

                  </React.Fragment>
                }                       
                
              </p>

              <div className="egitimGrid nomarginbottom">
                  <div className="egitimCol">
                    <img className="egitimColImg" src="/assets/images/meet1.jpg" alt={xprops.project.language.keywords.toplantiResim4} />
                    <p className="egitimColText"></p>
                  </div>
                  <div className="egitimCol">
                    <img className="egitimColImg" src="/assets/images/meet2.jpg" alt={xprops.project.language.keywords.toplantiResim4} />
                    <p className="egitimColText"></p>                    
                  </div>
                  <div className="egitimCol">
                    <img className="egitimColImg" src="/assets/images/meet3.jpg" alt={xprops.project.language.keywords.toplantiResim4} />
                    <p className="egitimColText"></p>                                        
                  </div>
              </div>              
              <div className="videoGrid">
                  <div className="videoCol">
                    <div className="videoPlayerWrapper">
                      <ReactPlayer
                          url='https://www.youtube.com/watch?v=kmHHeV0MffA'
                          className='react-player-video'
                          playing={false}
                          controls
                          width='100%'
                          height='100%'
                        />   

                    </div>
                    <p className="videoColText">{xprops.project.language.keywords.toplantiResim4}</p>                    
                  </div>
              </div>









            </div> 
            <br/><br/>     
          </div>
        </div>
        </div>
        <FooterNew />
      </React.Fragment>
    );
};

export default ToplantilarPage;